import React, { useState } from 'react';
import { Box } from '@mui/material';
import { Navigate, useNavigate } from 'react-router';

import { isUserLoggedIn, LoginScreen, StandardLoginScreenContents } from '@paragon/login-tools';

import { useAppSelector } from './hooks';

export function ServicesLogin() {
  const loggedInUser = useAppSelector((state) => isUserLoggedIn(state));
  const navigate = useNavigate();
  const [accountCreatedInCurrentFlow, setAccountCreatedInCurrentFlow] = useState(false);

  if (loggedInUser && !accountCreatedInCurrentFlow) return <Navigate to="/" replace />;
  return (
    <Box
      sx={{
        flexGrow: 1,
        height: 431,
        zIndex: 1,
        overflow: 'hidden',
        position: 'relative',
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      <LoginScreen>
        <StandardLoginScreenContents
          onResetPassword={(initialEmail) =>
            initialEmail ? navigate(`/resetpassword?email=${initialEmail}`) : navigate('/resetpassword')
          }
          onAccountCreated={() => setAccountCreatedInCurrentFlow(true)}
        />
      </LoginScreen>
    </Box>
  );
}
